import {Input} from "antd";
import {SendOutlined} from "@ant-design/icons";

import replyAvatar from "./reply-avatar.png";

import styles from "./dialog-card.module.scss";

const DialogCard = ({ticket_id, title, avatar, date, full_name, items}) => {
    const elements = items.map(({id, message, date, time}) =>   <div key={id} className={styles.dialog}>
        <p className={styles.dialogText}>{message}</p>
        <p className={styles.dialogDate}>{time} {date}</p>
    </div>);

    return (
        <div>
            <div className={styles.heading}>
                <div className={styles.avatar}>
                    {avatar && <img src={avatar} alt=""/>}
                </div>
                <div>
                    <p className={styles.status}><span className={styles.statusSubject}>Subject:</span> <span className={styles.statusName}>{title}</span></p>
                    <p className={styles.name}>{full_name}</p>
                    <p className={styles.date}>{date}</p>
                </div>
            </div>
            <div className={styles.dialogWrapper}>
                {elements}
            </div>
            <Input
                className={`${styles.field} ${styles.replyField}`}
                placeholder="Type answer here..."
                suffix={<SendOutlined onClick={()=> console.log("Send")} style={{ color: 'rgba(0,0,0,.45)' }} />}
            />
        </div>
    )
}

export default DialogCard;